export default __webpack_public_path__ + "static/media/aircraft-wing-desc.14971737.png";